import * as api from 'Shared/api';
import { handleError } from 'Shared/helpers';

import WpToastManager from 'Wpds/components/toast/WpToastManager';

export const disconnectDataSource = (id, name) => dispatch =>
  api.disonnectdataSource(id).then(
    () => {
      dispatch({
        type: 'DATA_SOURCE_DISCONNECT',
        payload: id,
      });
      if (name === 'Asana') {
        dispatch({
          type: 'DATA_SOURCE_DISCONNECT_ASANA',
        });
      }
      WpToastManager.success('Integration disconnected');
    },
    error => {
      dispatch(handleError(error));
    }
  );
